
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/gold-rates/[slug]",
      function () {
        return require("private-next-pages/gold-rates/[slug]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/gold-rates/[slug]"])
      });
    }
  